import React, { useState, useEffect, useCallback } from "react";
import NavigationSidebar from "../components/Navigationsidebar/NavigationSidebar";
import Header from "../components/Header";
import BarChartViz01 from "../components/Dashboardviz/D08/D08Viz01";
import BarChartViz02 from "../components/Dashboardviz/D08/D08Viz02";
import BarChartViz03 from "../components/Dashboardviz/D08/D08Viz03";
import BarChartViz04 from "../components/Dashboardviz/D08/D08Viz04";
import BarChartViz05 from "../components/Dashboardviz/D08/D08Viz05";
import QuestionsComponent from "../components/Dashboardviz/D08/D08Viz06"; // Import your questions component
import FilterSidebar from "../components/FilterSidebar/FilterSidebar";
import { useFilter } from "../FilterContext";
import { FILTER_CONFIG } from "../config/filterconfig";
import jsonData from "../current-survey-numeric.json";
import "./D08_Self_Reported_Engagement.css";

const D08_Self_Reported_EngagementDashboard = () => {
  const { filterCriteria, setFilterCriteria } = useFilter();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isFilterSidebarOpen, setIsFilterSidebarOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [isNarrativeOpen, setIsNarrativeOpen] = useState(false);
  const [narrative, setNarrative] = useState("");

  useEffect(() => {
    const generateFilterOptions = () => {
      const options = {};
      FILTER_CONFIG.forEach(({ fieldName, jsonKey, sortOrder }) => {
        let uniqueValues = [...new Set(jsonData.map((item) => item[jsonKey]))];
        uniqueValues = uniqueValues.filter(
          (value) => value !== null && value !== undefined
        );

        if (sortOrder) {
          uniqueValues = uniqueValues.sort(
            (a, b) => sortOrder.indexOf(a) - sortOrder.indexOf(b)
          );
        } else {
          uniqueValues = uniqueValues.sort((a, b) =>
            a?.localeCompare(b, undefined, { sensitivity: "base" })
          );
        }

        options[fieldName] = uniqueValues;
      });
      return options;
    };

    setFilterData(generateFilterOptions());
  }, []);

  const toggleSidebar = useCallback(
    () => setIsSidebarOpen((prev) => !prev),
    []
  );

  const toggleFilterSidebar = useCallback(
    () => setIsFilterSidebarOpen((prev) => !prev),
    []
  );

  const toggleNarrative = () => {
    setIsNarrativeOpen((prev) => !prev);
  };

  // Function to generate narrative summary (simplified example)
  const generateNarrative = () => {
    const summary = `
      Summary of Engagement Insights:

      Key Strengths:
      - 21.1% of respondents like their work, showing positive engagement.
      - 20.9% of respondents love their job, indicating strong job satisfaction.

      Areas for Consideration:
      - 22.0% of respondents neither like nor dislike their work, suggesting opportunities for improvement.
      - 20.8% strongly disagree about retention plans, indicating potential retention risks.

      Demographic Analysis:
      - Research department shows highest engagement at 89%.
      - Marketing department has lowest retention scores at 67%.
      
      Recommendations:
      - Focus on improving engagement for neutral respondents.
      - Develop targeted retention programs for departments with lower scores.
    `;

    setNarrative(summary);
  };

  // Generate narrative when filters change
  useEffect(() => {
    generateNarrative();
  }, [filterCriteria]);

  return (
    <div className="D08_Self_Reported_Engagement-dashboard-container">
      <Header
        title="Self Reported Engagement Dashboard"
        toggleSidebar={toggleSidebar}
        toggleFilterSidebar={toggleFilterSidebar}
      />
      <div className="D08_Self_Reported_Engagement-main-content">
        <NavigationSidebar
          className={
            isSidebarOpen
              ? "D08_Self_Reported_Engagement-navigation-sidebar-open"
              : "D08_Self_Reported_Engagement-navigation-sidebar-closed"
          }
          isOpen={isSidebarOpen}
        />
        <FilterSidebar
          className={
            isFilterSidebarOpen
              ? "D08_Self_Reported_Engagement-filter-sidebar-open"
              : "D08_Self_Reported_Engagement-filter-sidebar-closed"
          }
          isOpen={isFilterSidebarOpen}
          filterCriteria={filterCriteria}
          filterOptions={filterData}
          handleFilterChange={setFilterCriteria}
        />
        <div className="D08_Self_Reported_Engagement-narrative-button-container">
          <button
            className="D08_Self_Reported_Engagement-narrative-button"
            onClick={toggleNarrative}
          >
            Show Narrative Insights
          </button>
        </div>
      </div>

      <div className="D08_Self_Reported_Engagement-charts-wrapper">
        {/* First row of charts */}
        <div className="D08_Self_Reported_Engagement-chart">
          <h2 className="D08_Self_Reported_Engagement-chart-title">
            Type of Work
          </h2>
          <div className="D08_Self_Reported_Engagement-chart-container">
            <BarChartViz01 filterCriteria={filterCriteria} />
          </div>
        </div>
        
        <div className="D08_Self_Reported_Engagement-chart">
          <h2 className="D08_Self_Reported_Engagement-chart-title">
            Current Job
          </h2>
          <div className="D08_Self_Reported_Engagement-chart-container">
            <BarChartViz02 filterCriteria={filterCriteria} />
          </div>
        </div>
        
        <div className="D08_Self_Reported_Engagement-chart">
          <h2 className="D08_Self_Reported_Engagement-chart-title">
            Our Company Compared to Others
          </h2>
          <div className="D08_Self_Reported_Engagement-chart-container">
            <BarChartViz03 filterCriteria={filterCriteria} />
          </div>
        </div>

        {/* Second row with 2 charts and questions box */}
        <div className="D08_Self_Reported_Engagement-chart">
          <h2 className="D08_Self_Reported_Engagement-chart-title">
            Self Reported Retention
          </h2>
          <div className="D08_Self_Reported_Engagement-chart-container">
            <BarChartViz04 filterCriteria={filterCriteria} />
          </div>
        </div>
        
        <div className="D08_Self_Reported_Engagement-chart">
          <h2 className="D08_Self_Reported_Engagement-chart-title">
            Self Reported Engagement
          </h2>
          <div className="D08_Self_Reported_Engagement-chart-container">
            <BarChartViz05 filterCriteria={filterCriteria} />
          </div>
        </div>
        
        <div className="D08_Self_Reported_Engagement-chart">
          <h2 className="D08_Self_Reported_Engagement-chart-title">
            Questions
          </h2>
          <div className="D08_Self_Reported_Engagement-chart-container">
            <QuestionsComponent /> {/* Your Questions component */}
          </div>
        </div>
      </div>

      {isNarrativeOpen && (
        <div className="D08_Self_Reported_Engagement-narrative-modal">
          <div className="D08_Self_Reported_Engagement-narrative-content">
            <button
              className="D08_Self_Reported_Engagement-narrative-close-button"
              onClick={toggleNarrative}
            >
              Close
            </button>
            <h3>Narrative Insights</h3>
            <p style={{ whiteSpace: "pre-wrap" }}>{narrative}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default D08_Self_Reported_EngagementDashboard;